import track from '@/track'
import queryString from 'query-string'
import browser from '@beastshop/browser'
import bridge from '@beastshop/bridge'
import { gte, lt } from 'simple-semver'

import {
  getMiniEnv,
  navigateToMini
} from '@/miniprogram'

import {
  transformMiniLink 
} from './mini-link'
import { resolve } from 'url';

const version = browser.app() ? browser.app().version : ''

const REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i

// const route = {
//   'index': '/',
//   'shop': '/shop?shopId=',
//   'brand': '/product/list?',
//   'cate': '/product/list?',
//   'search': '/product/list?',
//   'retail': '/retail?',
//   'article': `/article?articleId=`,
//   'customization-list': `/customization/list?`,
//   'big-furniture-tips': '/furniture/tips?',
//   'shop-story': '/shop/story?',
//   'group-purchase': '/group/purchase?',
//   'points-benefit': '/points/benefit?',
//   'points-mall': '/member/day/points?',
//   'points-list': '/points/list?',
//   'points-detail': '/member/day/points/detail?',
//   'points-coupon': '/points/coupon?',
//   'category': '/category?',
//   'store': '/store?',
//   'cart': '/cart?',
//   'member': '/my?',
//   'my': '/my?',
//   'discovery': '/discovery?',
//   'funny': '/funny?',
//   'thh-page': '/ruler/thh',
//   'welfare': '/my/benefit/all?',
//   'benefit': '/my/benefit?',
//   'benefit-policy': '/benefit?',
//   'order-list': '/my/orderlist?',
//   'profile-setting': '/my/profile/edit',
//   'product': '/product/',
//   'shopping-fund': '/shopping/fund?',
//   'member-speed': '/member/speed?'
// }

const params = {
  'brand': 'brandId',
  // 'product': '*'
}

const route = {
  'index': {
    key: '/',
    type: '首页'
  },
  'shop': {
    key: '/shop?shopId=',
    type: '店铺页'
  },
  'brand': {
    key: '/product/list?',
    type: '商品列表页-品牌列表'
  },
  'cate': {
    key: '/product/list?',
    type: '商品列表页-分类列表'
  },
  'search': {
    key: '/product/list?',
    type: '商品列表页-搜索列表'
  },
  'retail': {
    key: '/retail?',
    type: ''
  },
  'article': {
    key: `/article?articleId=`,
    type: '专题页'
  },
  'customization-list': {
    key: `/customization/list?`,
    type: '商品列表页-定制列表'
  },
  'big-furniture-tips': {
    key: '/furniture/tips?',
    type: '大家具'
  },
  'shop-story': {
    key: '/shop/story?',
    type: '封面故事页'
  },
  'shop-story-all': {
    key: '/shop/story/all?',
    type: '全部封面故事页'
  },
  'group-purchase': {
    key: '/group/purchase?',
    type: '团购'
  },
  'points-benefit': {
    key: '/points/benefit?',
    type: '积分特权'
  },
  'points-mall': {
    key: '/member/day/points?',
    type: '积分商城'
  },
  'points-list': {
    key: '/points/list?',
    type: '积分列表'
  },
  'points-detail': {
    key: '/member/day/points/detail?',
    type: '积分详情页'
  },
  'points-coupon': {
    key: '/points/coupon?',
    type: '积分优惠券页'
  },
  'category': {
    key: '/category?',
    type: '选购'
  },
  'category-v2': {
    key: '/category/v2?',
    type: '选购'
  },
  'store': {
    key: '/store?',
    type: '门店'
  },
  'cart': {
    key: '/cart?',
    type: '购物车'
  },
  'member': {
    key: '/my?',
    type: '我的'
  },
  'my': {
    key: '/my?',
    type: '我的'
  },
  'discovery': {
    key: '/discovery?',
    type: '发现'
  },
  'funny': {
    key: '/funny?',
    type: '发现'
  },
  'thh-page': {
    key: '/ruler/thh',
    type: '退换货'
  },
  'welfare': {
    key: '/my/benefit/all?',
    type: '我的福利'
  },
  'benefit': {
    key: '/my/benefit?',
    type: '我的特权'
  },
  'benefit-policy': {
    key: '/benefit?',
    type: '特权政策'
  },
  'order-list': {
    key: '/my/orderlist?',
    type: '订单列表'
  },
  'profile-setting': {
    key: '/my/profile/edit',
    type: '个人信息设置'
  },
  'product': {
    key: '/product/',
    type: '商品详情页-普通商品'
  },
  'shopping-fund': {
    key: '/shopping/fund?',
    type: '购物基金'
  },
  'member-speed': {
    key: '/member/speed?',
    type: '会员等级'
  },
  'flower-list': {
    key: '/flower/list?',
    type: '花市列表'
  },
  'select-gift': {
    key: '/select/gift?',
    type: '选礼物'
  },
  'select-gift-result': {
    key: '/select/gift/result?',
    type: '选礼物结果'
  }
}

const app = browser.app()
const ios = browser.ios()
const android = browser.android()
const uniapp = browser.uniapp()

export function transformLink ({link, title = '', shopId = '', isMini = false}) {
  const _link = isMini
                ? transformMiniLink({link, title})
                : transformMLink({link, title, shopId})
  return _link
}

export function trackSkip ({trackData={}, link='', isMini = false, toMiniProgram = false}) {
  if(!link || link === "#") {
    return 
  }

  track(trackData)
  .then(() => {
    if(toMiniProgram) {//去小程序打开该页面
      openMiniProgram(link)
    } else if (isMini) {//小程序环境打开webview页面或者小程序内部页面
      navigateToMini(link)
    } else {
      if(app) {
        bridge.open({
          url: link
        })
      } else {
        window.location.href = link
      }
    }
  })
}

export function normalSkip ({link='', isMini = false, toMiniProgram = false}) {
  if(toMiniProgram) {//去小程序打开该页面
    openMiniProgram(link)
  } else if (isMini) {//小程序环境打开webview页面或者小程序内部页面
    navigateToMini(link)
  } else {
    if(app) {
      bridge.open({
        url: link
      })
    } else {
      window.location.href = link
    }
    // if(browser.app() && /^http/.test(link)) {
    //   bridge.open(link)
    // } else {
    //   window.location.href = link
    // }
  }
}

function openMiniProgram (link) {
  if (lt(version, '4.11.0')) {
    this.$alert({
      title: '请先去更新APP版本',
      content: '需要更新APP到最新版，才能进入查看哦！',
      buttonText: '知道了'
    })
    .then(() => {
      bridge.updateMobileVersion()
    })
  } else {
    bridge.openWXMiniProgram({
      path: link
    })
  }
}

export function appSkip (link) {
  // if(uniapp) {
  //   bridge.open({
  //     url: link
  //   })
  // } else {
  //   window.location.href = link
  // }
  bridge.open({
    url: link
  })
}

// export function skip ({link='', isMini = false}) {
//   if(!link || link === "#") {
//     return 
//   }

//   if (isMini) {
//     navigateToMini(link)
//   }
//   else {
//     window.location.href = link
//   }
// }

export function transformMLink ({link, title = '', shopId = ''}) {
  console.log('!!!!!!!!!!')
  if(!link.type) {
    return ''
  }
  let url = ""
  if(app) {
    url = `beastapp://`
  }
  title = encodeURIComponent(title)
  switch (link.type) {
    case 'none':
      return '#'
      break;
    case 'product':
      app
        ? url += `product/${link.value}`
        : url = `/product/${link.value}`
      break;
    case 'article':
      app
      ? url += `article/${link.value}`
      : url = `/article?articleId=${link.value}`
      break;
    case 'shop-story':
      app
      ? url += `entry?name=shop-story&shopId=${link.value}`
      : url = `/shop/story?shopId=${link.value}`
      break;
    case 'shop-story-all':
      app
      ? url += `entry?name=shop-story-all&shopId=${link.value}`
      : url = `/shop/story/all?shopId=${link.value}`
      break;
    case 'shop':
      app
      ? url += `shop/${link.value}`
      : url = `/shop?shopId=${link.value}`
      break;
    case 'list':
      app
      ? url += `search?listId=${link.value}&title=${title}`
      : url = `/product/list?listId=${link.value}&title=${title}`
      break;
    case 'new':
      app
      ? shopId
          ? url += `search?shopId=${shopId}&new=1&title=${title}`
          : url += `search?new=1&title=${title}`
      : shopId
          ? url = `/product/list?shopId=${shopId}&new=1&title=${title}`
          : url = `/product/list?new=1&title=${title}`
      break;
    case 'all':
      app
      ? shopId
          ? url += `search?shopId=${shopId}&title=${title}`
          : url += `search?title=${title}`
      : shopId
          ? url = `/product/list?shopId=${shopId}&title=${title}`
          : url = `/product/list?title=${title}`
      break;
    case 'brand':
      // ? url += `search?brandId=${link.value}&title=${title}`
      app 
        ? url += `entry?name=product-list&brandId=${link.value}&title=${title}`
        : url = `/product/list?brandId=${link.value}&title=${title}`
      break;
    case 'tag':
      app 
        ? url += `search?labelId=${link.value}&title=${title}`
        : url = `/product/list?labelId=${link.value}&title=${title}`
      break;
    case 'bu':
      let query = ""
      const idArr = link.value.split("-")
      if(!idArr.length) {
        return
      }
      if(idArr.length === 2 && idArr[1]) {
        query = `buId=${idArr[0]}&categoryId=${idArr[1]}&title=${title}`
      } else {
        query = `buId=${idArr[0]}&title=${title}`
      }

      app 
        ? url += `search?${query}`
        : url = `/product/list?${query}`
      break;
    case 'category':
      let cateStrs = ''
      link.value.split(',').forEach((v, index) => {
        cateStrs += `categoryId=${v}&`
      })

      app
        ? url += `search?${cateStrs}title=${title}`
        : url = `/product/list?${cateStrs}title=${title}`
      break;
    case 'oversea':
      app
        ? shopId
            ? url += `search?shopId=${shopId}&overseasOnly=true&title=${title}`
            : url += `search?overseasOnly=true&title=${title}`
        : shopId
            ? url += `/product/list?shopId=${shopId}&overseasOnly=true&title=${title}`
            : url += `/product/list?overseasOnly=true&title=${title}`
      break;
    case 'categoryOversea':
      let cateStrs1 = ''
      link.value.split(',').forEach((v, index) => {
        cateStrs1 += `categoryId=${v}&`
      })

      app
        ? shopId
            ? url += `search?shopId=${shopId}&overseasOnly=true&${cateStrs1}title=${title}`
            : url += `search?overseasOnly=true&${cateStrs1}title=${title}`
        : shopId
            ? url += `/product/list?shopId=${shopId}&overseasOnly=true&${cateStrs1}title=${title}`
            : url += `/product/list?overseasOnly=true&${cateStrs1}title=${title}`
      break;
    case 'campaign':
      app
      ? url += `search?campaignCode=${link.value}&title=${title}`
      : url = `/product/list?campaignCode=${link.value}&title=${title}`
      break;
    case 'article-list':
      let idStrs = ''
      link.value.split(',').forEach((v, index) => {
        idStrs += `articleId=${v}&`
      })
      app 
        ? url += `entry?name=article-list&type=article-list&${idStrs}title=${title}`
        : url = `/article/list?type=article-list&${idStrs}title=${title}`
      break;
    case 'lesson':
      app 
        ? url += `entry?name=article-list&type=LESSON&title=${title}`
        : url = `/article/list?type=LESSON&title=${title}`
      break;
    case 'group':
      app 
        ? url += `entry?name=group-purchase&productId=${link.value}`
        : url = `/group/purchase?productId=${link.value}`
      break;
    case 'customization-list':
      app 
        ? url += `entry?name=customization-list`
        : url = `/customization/list`
      break;
    case 'deeplink':
      app
        ? url = link.value
        : url = dealMLink(link.value)
      break;

    case 'custom':
      app 
        ? url += `entry?name=customization-list`
        : url = ''
      break;
    case 'discount':
      app 
        ? url += `search?param=discount&title=折扣`
        : url = `/product/list?param=discount&title=折扣`
      break;
    case 'retail':
      app
        ? url += `entry?name=retail&title=实体店`
        : url = `/retail`
      break;
    case 'index':
      app
        ? url += `index`
        : url = '/'
      break;
    case 'program':
      url = ''
      break;
    case 'web':
      url = link.value
      break;
    case 'selfdefine':
      app
        ? url = link.deeplink
        : url = link.waplink
      break;
  }
  console.log(url, "$$$$$$$$$$")
  return url
}

function dealMLink (link) {
  if(/^http/.test(link)) {//http
    return link
  }
  if (link === 'beastapp://index') {
    link = '/'
  }
  else if (link === 'beastapp://my') {
    link = '/my'
  }
  else if (link === 'beastapp://profile-settings') {
    link = '/my/profile/edit'
  }
  else if (link === 'beastapp://order-list') {
    link = '/my/orderlist'
  }
  else if (link === 'beastapp://score') {
    link = '/my/score'
  }
  else if (link === 'beastapp://cart') {
    link = '/cart'
  }
  else if (link === 'beastapp://benefit') {
    link = '/my/benefit'
  }
  else {
    // link = splitQue(link)
    link = splitQue(link).que
  }

  return link
}

function dealMLinkPage (link) {
  let skip_page_type = ''

  if(/^http/.test(link)) {//http
    return {
      link,
      skip_page_type
    }
  }
  if (link === 'beastapp://index') {
    skip_page_type = '首页'
    link = '/'
  }
  else if (link === 'beastapp://my') {
    skip_page_type = '我的'
    link = '/my'
  }
  else if (link === 'beastapp://profile-settings') {
    skip_page_type = '编辑个人信息'
    link = '/my/profile/edit'
  }
  else if (link === 'beastapp://order-list') {
    skip_page_type = '订单列表'
    link = '/my/orderlist'
  }
  else if (link === 'beastapp://score') {
    skip_page_type = '我的积分'
    link = '/my/score'
  }
  else if (link === 'beastapp://cart') {
    skip_page_type = '购物车'
    link = '/cart'
  }
  else if (link === 'beastapp://benefit') {
    skip_page_type = '我的特权'
    link = '/my/benefit'
  }
  else {
    skip_page_type = splitQue(link).trackType
    link = splitQue(link).que
  }

  return {
    link,
    skip_page_type
  }
}

function splitQue (query) {
  let que = REG.exec(query)
  let type = que[1]
  let search = que[2]
  let name = ''
  let trackType = ''
  // entry
  if (type === 'entry') {
    type = queryString.parse(search).name
  }

  // if (type && search) {
  //   que = matchQue(type, search)
  // }
  if (type && search) {
    const queObj = matchQue(type, search)
    que = queObj.que
    trackType = queObj.trackType
  }

  // return que
  return {
    que,
    trackType
  }
}

function matchQue (type, query) {
  let que = ''
  type = type.split('/')

  // const path = route[type[0]]
  // const pid = params[type[0]]
  if(route[type[0]]) {
    const path = route[type[0]].key
    const trackType = route[type[0]].type || ''
    const pid = params[type[0]]

    if (path) {
      que = type[1] && pid
        ? pid === '*'
          ? `${path}${type[1]}?${query}`
          : `${path}${pid}=${type[1]}&${query}`
        : pid
          ? `${path}${pid}=${query}`
          : `${path}${query}`
    }
    else {
      que = `/${type[0].replace('-', '/')}`
    }

    // return que
    return {
      que,
      trackType
    }
  } else {
    return {
      que: '#',
      trackType: ''
    }
  }
}

export function getToMiniLink ({link, title}) {
  const miniLink = transformMiniLink({link, title})
  return miniLink.url
}

export function getLinkPageData ({link, title = ''}) {
  let skip_page_type = '',
      skip_page_name = '',
      skip_page_id = '';

  if(!link.type) {
    return {
      skip_page_type,
      skip_page_name,
      skip_page_id
    }
  }

  switch (link.type) {
    case 'none':
      break;
    case 'product':
      skip_page_type = '商品详情页-普通商品'
      skip_page_id = link.value
      break;
    case 'article':
      skip_page_type = '专题页'
      skip_page_id = link.value
      break;
    case 'shop-story':
      skip_page_type = '封面故事页'
      skip_page_id = link.value
      break;
    case 'shop':
      skip_page_type = '店铺主页'
      skip_page_id = link.value
      break;
    case 'list':
      skip_page_type = '商品列表页-运营list'
      skip_page_name = title || ''
      skip_page_id = link.value
      break;
    case 'new':
      skip_page_type = '商品列表页-新鲜上架'
      skip_page_name = title || ''
      break;
    case 'all':
      skip_page_type = '商品列表页-全部商品'
      skip_page_name = title || ''
      break;
    case 'brand':
      skip_page_type = '商品列表页-品牌列表'
      skip_page_name = title || ''
      skip_page_id = link.value
      break;
    case 'tag':
      skip_page_type = '商品列表页-标签列表'
      skip_page_name = title || ''
      skip_page_id = link.value
      break;
    case 'bu':
      skip_page_type = '商品列表页-BU商品列表'
      skip_page_name = title || ''
     
      const idArr = link.value.split("-")
      if(idArr.length) {
        skip_page_id = idArr[0] || ''
      }
      break;
    case 'category':
      let cateStrs = ''
      link.value.split(',').forEach((v, index) => {
        cateStrs += `categoryId=${v}&`
      })

      skip_page_type = '商品列表页-分类列表'
      skip_page_name = title || ''
      skip_page_id = cateStrs
      break;
    case 'oversea':
      skip_page_type = '商品列表页-海淘列表'
      skip_page_name = title || ''
      break;
    case 'categoryOversea':
      let cateStrs1 = ''
      link.value.split(',').forEach((v, index) => {
        cateStrs1 += `categoryId=${v}&`
      })

      skip_page_type = '商品列表页-海淘分类列表'
      skip_page_name = title || ''
      skip_page_id = cateStrs1
      break;
    case 'article-list':
      let idStrs = ''
      link.value.split(',').forEach((v, index) => {
        idStrs += `articleId=${v}&`
      })

      skip_page_type = '专题列表'
      skip_page_name = title || ''
      skip_page_id = idStrs
      break;
    case 'lesson':
      skip_page_type = '野兽课堂列表页'
      skip_page_name = title || ''
      break;
    case 'group':
      skip_page_type = '商品详情页-团购商品'
      skip_page_id = link.value
      break;
    case 'customization-list':
      skip_page_type = '商品列表页-定制列表'
      break;
    case 'deeplink':
      let dealLink = dealMLinkPage(link.value)
      skip_page_type = dealLink.skip_page_type
      break;
    case 'custom':
      skip_page_type = '商品列表页-定制列表'
      break;
    case 'discount':
      skip_page_type = '商品列表页-折扣列表'
      skip_page_name = '折扣'
      break;
    case 'index':
      skip_page_type = '首页'
      break;
    case 'program':
      skip_page_type = '小程序页面'
      break;
    case 'web':
      skip_page_type = '网页'
      skip_page_name = link.value
      break;
    case 'selfdefine':
      skip_page_type = '自定义页面'
      skip_page_name = app?link.deeplink:link.waplink
      break;
  }

  return {
    skip_page_type,
    skip_page_id,
    skip_page_name
  }
}



// WEBPACK FOOTER //
// ./static/link/index.js